import React from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { getStatisticsUrl } from '../../../../../utils/render';
import { getMoreMarketsUrl, isESportEvent } from '../../../../../utils/helpers';
import EventInfo from '../../../../shared/Events/Table/EventInfo/EventInfo';
import Mbn from '../../../../shared/Events/Table/Mbn/Mbn';
import Markets from '../../../../shared/Events/Table/Markets/Markets';
import MoreMarkets from '../../../../shared/Events/Table/MoreMarkets/MoreMarkets';
import ProgramCode from '../../../../shared/Events/Table/ProgramCode/ProgramCode';
import Statistics from '../../../../shared/Events/Table/Statistics/Statistics';
import { LANGUAGES } from '../../../../../constants/defaultValues';

const Row = ({ event }) => {
    const history = useHistory();

    const locale = useSelector(state => state.settings.locale);
    const leagues = useSelector(state => state.sportEvents.filters.leagues) || [];
    const { isESports } = useSelector(state => state.sportEvents);

    const { id, programCode, teams, startedAt, mbn, liveStatistics, categoryName } = event;
    const currentSeasonId = event.currentSeasonId || '';

    const foundLeague = leagues.find(league => league.id === event.seasonRefId);
    const eventLeague = foundLeague?.names[locale] || foundLeague?.names[LANGUAGES.eng] || '';
    const homeTeamId = teams.homeCompetitorId?.slice(16);
    const awayTeamId = teams.awayCompetitorId?.slice(16);
    let seasonId = currentSeasonId?.split(':');
    seasonId = seasonId[seasonId.length - 1];
    let eventId = id?.replace('1:', '');
    const statisticsUrl = getStatisticsUrl({ seasonId, eventId, homeTeamId, awayTeamId });

    const onRowClick = () => {
        const redirectUrl = getMoreMarketsUrl({ event });
        history.push(redirectUrl);
    };

    return (
        <tr onClick={onRowClick}>
            <ProgramCode programCode={programCode} />
            <EventInfo
                eventId={id}
                league={eventLeague}
                teams={teams}
                categoryName={categoryName}
                liveStatistics={liveStatistics}
            />
            <Statistics statistics={liveStatistics} startedAt={startedAt} isLive={event.live} isBooked={event.booked} />
            <Mbn mbn={mbn} statisticsUrl={statisticsUrl} isESports={isESports} />
            <Markets event={event} />
            <MoreMarkets event={event} />
        </tr>
    );
};

export default Row;
